var map = {
	"./flags/be.svg": 27,
	"./flags/cn.svg": 28,
	"./flags/de.svg": 29,
	"./flags/es.svg": 30,
	"./flags/fr.svg": 31,
	"./flags/gb.svg": 32,
	"./flags/it.svg": 33,
	"./flags/jp.svg": 34,
	"./flags/us.svg": 35,
	"./icons/arrow-down.svg": 36,
	"./icons/back.svg": 37,
	"./icons/close.svg": 38,
	"./icons/contact.svg": 39,
	"./icons/error.svg": 40,
	"./icons/facebook.svg": 41,
	"./icons/info.svg": 42,
	"./icons/instagram.svg": 43,
	"./icons/linkedin.svg": 44,
	"./icons/marker.svg": 45,
	"./icons/newsletter.svg": 46,
	"./icons/search.svg": 47,
	"./icons/slider-arrow.svg": 48,
	"./icons/success.svg": 49,
	"./icons/tiktok.svg": 50,
	"./icons/twitter-x.svg": 51,
	"./icons/twitter.svg": 52,
	"./icons/weibo.svg": 53,
	"./icons/whatsapp.svg": 54,
	"./icons/youtube.svg": 55,
	"./line-bottom-manifest.svg": 56,
	"./line-decoration-image.svg": 57,
	"./line-fullwidth-image.svg": 58,
	"./line-hero.svg": 59,
	"./line-top-manifest.svg": 60,
	"./logo.png": 61,
	"./quote.svg": 62
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;